import { normalizeBuyerIntentId, normalizeBuyerIntentIds } from './idNormalization'

export const normalizeBuyerIntentProps = ({ productId, productIds, categoryId, categoryIds }) => {
  const normalizedProductId = normalizeBuyerIntentId(productId)
  const normalizedProductIds = normalizeBuyerIntentIds(productIds)
  const normalizedCategoryId = normalizeBuyerIntentId(categoryId)
  const normalizedCategoryIds = normalizeBuyerIntentIds(categoryIds)

  return {
    ...(normalizedProductId ? { productId: normalizedProductId } : {}),
    ...(normalizedProductIds.length > 0 ? { productIds: normalizedProductIds } : {}),
    ...(normalizedCategoryId ? { categoryId: normalizedCategoryId } : {}),
    ...(normalizedCategoryIds.length > 0 ? { categoryIds: normalizedCategoryIds } : {}),
  }
}

export const hasBuyerIntentIdentifiers = intentProps =>
  Boolean(
    intentProps.productId || intentProps.categoryId || intentProps.productIds?.length || intentProps.categoryIds?.length
  )
